import { useContext } from 'react';
import { PharmacyContext } from './pharmacy-context';

export const useSelectedPharmacy = () => {
  const context = useContext(PharmacyContext);

  if (context === undefined) {
    throw new Error(
      'useSelectedPharmacy must be used within a PharmacyProvider'
    );
  }

  return context;
};
